import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-appheader',
  templateUrl: './appheader.component.html',
  styleUrls: ['./appheader.component.css']
})
export class AppheaderComponent implements OnInit {
  userType: string;
  admin: boolean;
  admin_name: string;

  constructor(private authService: AuthenticationService, private router: Router, private dialog: MatDialog, ) { }

  ngOnInit() {
    
   this.userType = localStorage.getItem('userType');
   if (this.userType === 'support') {
    this.admin = false;
    this.admin_name = 'Support';
  } else if (this.userType === 'superadmin') {
    this.admin = true;
    this.admin_name = 'Superadmin';
  } else {
    this.admin = true;
    this.admin_name = 'Marketing';
  }
  }
   logout() {
    this.authService.logout()
    .subscribe(res => {
      if (this.admin_name === 'Superadmin') {
      this.router.navigate(['../../login']);
      } else {
      this.router.navigate(['logout']);
      }
    });

   }

   openDialog(): void {
    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      width: '600px',

    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

}
